function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'soft-blauw': 'rgb(127, 192, 219)','soft-groen': 'rgb(156, 198, 188)','soft-oranje': 'rgb(242, 205, 141)','soft-violet': 'rgb(174, 169, 213)','soft-roze': 'rgb(243, 178, 204)','soft-geel': 'rgb(232, 226, 161)','zwart': 'rgb(0, 0, 0)','blauwzwart': 'rgb(29, 0, 91)','donkerblauw': 'rgb(29, 26, 115)','blauw': 'rgb(30, 61, 126)','lichtblauw': 'rgb(2, 183, 229)','hemelsblauw': 'rgb(5, 130, 208)','bruin': 'rgb(144, 77, 55)','groen': 'rgb(0, 130, 89)','lichtgroen': 'rgb(130, 162, 42)','lichtoranje': 'rgb(251, 209, 190)','oranje': 'rgb(246, 130, 0)','abrikoos': 'rgb(251, 161, 42)','rood': 'rgb(208, 41, 55)','wijnrood': 'rgb(147, 41, 85)','paars': 'rgb(168, 63, 164)','violet': 'rgb(87, 58, 144)','roze': 'rgb(242, 105, 149)','koraalroze': 'rgb(242, 115, 101)','wit': 'rgb(255, 255, 255)','grijs': 'rgb(220, 222, 225)','metallic-zwart': 'rgb(35, 34, 39)','metallic-grijs': 'rgb(71, 77, 91)','metallic-roze': 'rgb(185, 150, 156)','metallic-beige': 'rgb(180, 175, 171)','metallic-koraal': 'rgb(212, 84, 82)','metallic-hemelsblauw': 'rgb(90, 100, 139)','metallic-marineblauw': 'rgb(62, 61, 92)','metallic-champagne-goud': 'rgb(189, 118, 111)','metallic-zilver': 'rgb(169, 168, 179)','70-111-baby-blauw': 'rgb(184, 204, 225)','70-31-blauw': 'rgb(125, 179, 227)','70-126-cremig-perzik': 'rgb(241, 155, 128)','70-158-fris-fuchsia': 'rgb(212, 159, 198)','70-24-geel': 'rgb(233, 229, 72)','70-33-groen': 'rgb(115, 182, 69)','70-150-kersenbloesem-roze': 'rgb(238, 121, 148)','70-55-lavendel': 'rgb(137, 99, 164)','70-58-lila': 'rgb(210, 75, 144)','70-155-lila-blush': 'rgb(207, 167, 209)','70-112-luchtig-blauw': 'rgb(158, 207, 230)','70-144-melkachtig-geel': 'rgb(233, 219, 119)','70-194-mistig-grijs': 'rgb(190, 196, 200)','70-54-oranje': 'rgb(243, 161, 84)','70-129-poederroze': 'rgb(240, 171, 191)','70-40-rood': 'rgb(231, 99, 95)','70-56-roze': 'rgb(235, 95, 115)','70-133-snufje-limoen': 'rgb(219, 226, 131)','70-51-turquoise': 'rgb(43, 164, 137)','70-116-vleugje-mint': 'rgb(179, 216, 180)','70-113-vleugje-turquoise': 'rgb(175, 216, 207)','70-140-zacht-koraal-rood': 'rgb(238, 108, 83)','70-125-zacht-oranje': 'rgb(239, 184, 128)',};

    this.images = {'multicolor': 'url("//planjeweek.nl/cdn/shop/files/Multicolor_68x.png?v=4055661287417775326")',};

    this.triggers = ['color','colour','couleur','farbe','cor','kleur','pilot frixion ball clicker pen medium penpunt 0.7 mm - diverse kleuren (kleur)','pilot frixion set van 3 navullingen medium penpunt 0.7 mm - diverse kleuren (kleur)','pilot frixion remover wisser (kleur)','kleur:',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
